function getDifferenceInMinutes(startDate, endDate) {
  return Math.round((((startDate - endDate) % 86400000) % 3600000) / 60000);
}

function isToday(dateObject) {
  const dateToCompare = new Date(
    dateObject.getFullYear(),
    dateObject.getMonth(),
    dateObject.getDate(),
  );

  const now = new Date();
  const today = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
  );

  return today.valueOf() === dateToCompare.valueOf();
}

function subtractMinutes(date, minutes) {
  return new Date(date - minutes * 60000);
}

function addDays(date, days) {
  return new Date(new Date().setDate(new Date(date).getDate() + days));
}

function addMinutes(date, minutes) {
  return new Date(date + minutes * 60000);
}

export {
  getDifferenceInMinutes,
  isToday,
  subtractMinutes,
  addDays,
  addMinutes,
};
